import React from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { patchUrlByLocale } from 'utils';
import { pdpSectionStyle } from 'common/components/page-section';
import { Breadcrumb } from 'features/page-model';
import { cx } from 'linaria';
import { section } from './styles';

export const PDP_BREADCRUMPS_ID = 'breadcrumbs';

type Props = { data: Breadcrumb[] } & React.HTMLAttributes<HTMLElement>;

export const PdpBreadcrumps: React.FC<Props> = ({ data, className }) => (
  <section data-qa={PDP_BREADCRUMPS_ID} className={cx(pdpSectionStyle, section, className || '')}>
    <Breadcrumbs addSEOAttributes={false}>
      {data.map(({ link, label }) => (
        <BreadcrumbsItem key={link} href={patchUrlByLocale(link)}>
          {label}
        </BreadcrumbsItem>
      ))}
    </Breadcrumbs>
  </section>
);
